import InputNoView from './InputNoView';

export default InputNoView;
